(function () {
  if (window.TFZipCodeCheckerLoaded) return;
  window.TFZipCodeCheckerLoaded = true;

  function normalizeZip(value) {
    var match = String(value || '').trim().match(/^(\d{5})(?:-\d{4})?$/);
    return match ? match[1] : '';
  }

  function parseSupportedZips(value) {
    return String(value || '')
      .split(/[\s,]+/)
      .map(normalizeZip)
      .filter(Boolean);
  }

  function initZipCodeChecker() {
    var modal = document.querySelector('[data-zip-checker-modal]');
    if (!modal) return;

    var triggers = Array.prototype.slice.call(document.querySelectorAll('[data-zip-checker-open]'));
    var form = modal.querySelector('[data-zip-checker-form]');
    var input = modal.querySelector('[data-zip-checker-input]');
    var result = modal.querySelector('[data-zip-checker-result]');
    var resultTitle = modal.querySelector('[data-zip-checker-result-title]');
    var resultMessage = modal.querySelector('[data-zip-checker-result-message]');
    var closeButtons = Array.prototype.slice.call(modal.querySelectorAll('[data-zip-checker-close]'));
    var supportedZips = parseSupportedZips(modal.dataset.supportedZips);
    var lastTrigger = null;

    function setResult(title, message, type) {
      if (!result) return;
      if (resultTitle) resultTitle.textContent = title;
      if (resultMessage) resultMessage.textContent = message;
      result.classList.remove('is-success', 'is-error');
      result.classList.add(type === 'success' ? 'is-success' : 'is-error');
      result.hidden = false;
    }

    function resetResult() {
      if (!result) return;
      if (resultTitle) resultTitle.textContent = '';
      if (resultMessage) resultMessage.textContent = '';
      result.classList.remove('is-success', 'is-error');
      result.hidden = true;
    }

    function openModal(trigger) {
      lastTrigger = trigger || null;
      modal.hidden = false;
      document.body.classList.add('zip-checker-modal-open');
      resetResult();

      window.requestAnimationFrame(function () {
        if (input) input.focus();
      });
    }

    function closeModal() {
      if (modal.hidden) return;
      modal.hidden = true;
      document.body.classList.remove('zip-checker-modal-open');
      resetResult();

      if (lastTrigger && typeof lastTrigger.focus === 'function') {
        lastTrigger.focus();
      }
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openModal(trigger);
      });
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();

        if (!result || !input) return;

        var enteredZip = normalizeZip(input.value);
        if (!enteredZip) {
          setResult(
            result.dataset.invalidTitle || 'Try again',
            result.dataset.invalidMessage || 'Enter a valid 5-digit ZIP code.',
            'error'
          );
          return;
        }

        if (!supportedZips.length) {
          setResult(
            result.dataset.emptyTitle || 'ZIP list missing',
            result.dataset.emptyMessage || 'Add supported ZIP codes in Theme settings to enable this checker.',
            'error'
          );
          return;
        }

        if (supportedZips.indexOf(enteredZip) !== -1) {
          setResult(
            result.dataset.successTitle || 'Good news!',
            result.dataset.successMessage || 'Good news. We deliver to your area.',
            'success'
          );
        } else {
          setResult(
            result.dataset.failureTitle || 'Not yet!',
            result.dataset.failureMessage || 'We do not deliver to that ZIP code yet.',
            'error'
          );
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initZipCodeChecker);
  } else {
    initZipCodeChecker();
  }
})();
